import template from './branch.all.html';
import controller from './branch.all.controller';
import './branch.all.scss';

let branchallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default branchallComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch/all/branch.all.component.js